import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate();
    const handleClickHome = () => {
        navigate('/dashboard');
    }

    return (
        <Result
            status="404"
            title="404"
            subTitle="К сожалению, страница, которую вы посетили, не существует."
            extra={<Button type="primary" onClick={handleClickHome}>Домой</Button>}
        />
    );
}

export default NotFound;
